export class TvAccountTodaysResultData {
    public todaysGross: number = 0;
    public todaysNet: number = 0;
    public todaysFees: number = 0;
    public todaysVolume: number = 0;
    public todaysTrades: number = 0;
}
